let localsData; // Renamed to avoid shadowing

document.addEventListener("DOMContentLoaded", function () {
  fetchLocalsData();
});

function localAccordionTemplate(local, regionId) {
  if (local.show_under_map_bool !== true) {
    return null;
  }
  const tempContainer = document.createElement("div");
  tempContainer.innerHTML = `<div class="accordion-item">
    <h3 class="accordion-header">
      <button
        class="accordion-button collapsed"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#local-${local.local_id}"
        aria-expanded="false"
        aria-controls="local-${local.local_id}">
      <span><i class="AccordionIcon pe-3"></i></span> 
      <span class="has-dark-color">${local.local_number} - ${local.name}</span>
      </button>
    </h3>
    <div
      id="local-${local.local_id}"
      class="accordion-collapse collapse"
      data-bs-parent="local-list-${regionId}">
      <div class="accordion-body">${local.info}</div>
    </div>
  </div>`;

  return tempContainer.firstChild;
}

function fetchLocalsData() {
  axios
    .post(
      locals_ajax.ajax_url,
      Qs.stringify({
        action: "get_locals_json",
        nonce: locals_ajax.nonce,
      })
    )
    .then(handleResponse)
    .catch(handleError);
}

function handleResponse(response) {
  if (!response.data || response.data.success === false) {
    console.error("Error:", response.data.message || "Failed to fetch locals.");
    return;
  }

  console.log(response.data); 

  localsData = groupLocalsByRegion(response.data);

  localsData = Object.keys(localsData)
    .sort()
    .reduce((acc, key) => {
      acc[key] = localsData[key];
      return acc;
    }, {});
  initMap();
}

function handleError(error) {
  console.error("Request failed:", error);
}

function groupLocalsByRegion(data) {
  return data.reduce((acc, local) => {
    if (!acc[local.region]) {
      acc[local.region] = [];
    }

    acc[local.region].push(local);
    acc[local.region].sort((a, b) => a.local_number - b.local_number);

    return acc;
  }, {});
}

function buildLocalList(region, local) {
  const regionId = generateRegionId(region);
  let regionSection = document.getElementById(`wrapper-${regionId}`);

  if (regionSection) {
    const localAccordion = localAccordionTemplate(local, regionId);
    if (localAccordion) {
      const localList = regionSection.querySelector(`#local-list-${regionId}`);
      console.log("appending", local.local_number, "to", regionId);
      localList.appendChild(localAccordion);
    }
  }
}

function generateRegionId(region) {
  return region
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, "-")
    .toLowerCase();
}

function createRegionSection(regionId, region) {
  const regionSection = document.createElement("div");
  regionSection.id = `wrapper-${regionId}`;
  regionSection.classList.add("accordion");

  const regionHeader = document.createElement("h2");
  regionHeader.classList.add("my-3");

  const regionButton = document.createElement("span");
  regionButton.innerHTML = `<span><i class="AccordionIcon pe-3"></i></span> <span class="has-dark-color">${region}</span>`;
  regionButton.classList.add("accordion-button");
  regionButton.classList.add("collapsed");
  regionButton.setAttribute("data-bs-toggle", "collapse");
  regionButton.setAttribute("data-bs-target", `#local-list-${regionId}`);
  regionButton.setAttribute("aria-expanded", "false");
  regionButton.setAttribute("aria-controls", `local-list-${regionId}`);

  const localList = document.createElement("div");
  localList.classList.add("local-list");
  localList.classList.add("accordion-collapse");
  localList.classList.add("collapse");
  localList.classList.add("ms-4");
  localList.dataset.bsParent = `wrapper-${regionId}`;
  localList.id = `local-list-${regionId}`;

  regionHeader.appendChild(regionButton);
  regionSection.appendChild(regionHeader);
  regionSection.appendChild(localList);

  document.querySelector("#localsAccordion").appendChild(regionSection);
}

async function initMap() {
  await customElements.whenDefined("gmp-map");

  const map = document.querySelector("gmp-map");
  const placePicker = document.querySelector("gmpx-place-picker");
  const infowindow = new google.maps.InfoWindow();
  const bounds = new google.maps.LatLngBounds();

  map.innerMap.setOptions({ mapTypeControl: false });

  Object.keys(localsData).forEach((region) => {
    const regionId = generateRegionId(region);
    createRegionSection(regionId, region);
    localsData[region].forEach((local) => {
      buildLocalList(region, local);
      if (local.latitude && local.longitude) {
        addMarker(map, infowindow, bounds, local);
      }
    });
  });

  map.innerMap.fitBounds(bounds);
  setupPlacePicker(placePicker, map, infowindow);
}

function addMarker(map, infowindow, bounds, local) {
  const marker = new google.maps.Marker({
    position: { lat: local.latitude, lng: local.longitude },
    map: map.innerMap,
    title: local.name,
  });

  bounds.extend({ lat: local.latitude, lng: local.longitude });

  marker.addListener("click", () => {
    const latLng = `Lat: ${local.latitude}, Lng: ${local.longitude}`;
    infowindow.setContent(`${local.name}<br>${local.info}<br><small>${latLng}</small>`);
    map.innerMap.setCenter(marker.getPosition());
    map.innerMap.setZoom(17);
    infowindow.open(map.innerMap, marker);
  });
}

function setupPlacePicker(placePicker, map, infowindow) {
  placePicker.addEventListener("gmpx-placechange", () => {
    const place = placePicker.value;

    if (!place.location) {
      window.alert("No details available for input: '" + place.name + "'");
      infowindow.close();
      return;
    }

    map.innerMap.setCenter(place.location);
    map.innerMap.setZoom(10);
  });
}
